import React from 'react';

const ListEmpty = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="228" height="102" viewBox="0 0 228 102">
        <defs>
            <rect id="no-found-result-b" width="200" height="45" />
            <filter
                id="no-found-result-a"
                width="105.5%"
                height="124.4%"
                x="-2.8%"
                y="-7.8%"
                filterUnits="objectBoundingBox"
            >
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                    stdDeviation="1.5"
                />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
                />
            </filter>
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(3 1)">
            <path
                fill="#FFF"
                stroke="#999"
                strokeDasharray="5 6"
                strokeLinecap="round"
                strokeWidth="2"
                d="M0,55 L200,55 L200,100 L0,100 L0,55 Z"
                opacity=".4"
            />
            <use fill="#000" filter="url(#no-found-result-a)" xlinkHref="#no-found-result-b" />
            <use fill="#FFF" xlinkHref="#no-found-result-b" />
            <circle cx="21" cy="23" r="11" fill="#F04540" opacity=".6" />
            <rect width="100" height="5" x="42" y="17" fill="#EDEDED" rx="2.5" />
            <rect width="70" height="4" x="42" y="26" fill="#EDEDED" rx="2" />
            <path
                fill="#FFF"
                fillRule="nonzero"
                d="M19.47043,22.8846436 L17.2928932,20.7071068 C16.9023689,20.3165825 16.9023689,19.6834175 17.2928932,19.2928932 C17.6834175,18.9023689 18.3165825,18.9023689 18.7071068,19.2928932 L20.8846436,21.47043 L23.0621803,19.2928932 C23.4527046,18.9023689 24.0858696,18.9023689 24.4763939,19.2928932 C24.8669182,19.6834175 24.8669182,20.3165825 24.4763939,20.7071068 L22.2988571,22.8846436 L24.4763939,25.0621803 C24.8669182,25.4527046 24.8669182,26.0858696 24.4763939,26.4763939 C24.0858696,26.8669182 23.4527046,26.8669182 23.0621803,26.4763939 L20.8846436,24.2988571 L18.7071068,26.4763939 C18.3165825,26.8669182 17.6834175,26.8669182 17.2928932,26.4763939 C16.9023689,26.0858696 16.9023689,25.4527046 17.2928932,25.0621803 L19.47043,22.8846436 Z"
                opacity=".8"
            />
            <g fillRule="nonzero" transform="translate(174 34)">
                <circle cx="22.536" cy="21.592" r="19.592" fill="#D0E8F9" />
                <path
                    fill="#EAF6FD"
                    d="M29.642,3.348 L4.294,28.696 C5.706,32.316 8.154,35.41 11.284,37.614 L38.56,10.34 C36.356,7.208 33.262,4.76 29.642,3.348 Z"
                />
                <path
                    fill="#4B5971"
                    d="M50.426,48.582 L38.486,36.094 C41.978,32.256 44.126,27.178 44.126,21.592 C44.128,9.686 34.442,0 22.536,0 C10.63,0 0.944,9.686 0.944,21.592 C0.944,33.498 10.63,43.184 22.536,43.184 C27.42,43.184 31.914,41.536 35.534,38.792 L47.536,51.344 C47.928,51.756 48.454,51.962 48.982,51.962 C49.48,51.962 49.976,51.778 50.364,51.408 C51.162,50.646 51.19,49.378 50.426,48.582 Z M4.944,21.592 C4.944,11.892 12.836,4 22.536,4 C32.236,4 40.128,11.892 40.128,21.592 C40.128,31.292 32.236,39.184 22.536,39.184 C12.836,39.184 4.944,31.292 4.944,21.592 Z"
                />
            </g>
        </g>
    </svg>
);

export default ListEmpty;
